import React from 'react';
import DataModelReportsRow from '../containers/DataModelReportsTableRow';

const DataModelReportsTableRows = ({
  category,
  code,
  reports,
  columns,
}) => (
  reports.map((report, index) => (
    <DataModelReportsRow
      key={`dataset_data_management_data_model_reports_table_row_${report.id}`}
      category={category}
      code={code}
      reportId={report.id}
      columns={columns}
      upward={index > 4}
    />
  ))
);

export default DataModelReportsTableRows;
